export default __webpack_public_path__ + "static/logo-8-fc59002be9793a02cb9a6e9eafd26c7b.jpeg";